import { GearIcon, MoonIcon } from '@phosphor-icons/react';
import {
  Stack,
  Spread,
  Inline,
  IconRenderer,
  Toggle,
  Text,
} from 'braid-design-system';
import { useEffect, useState } from 'react';
import { useLazyColorMode } from '#src/components/ColorModeProvider/ColorModeProvider.tsx';
import { ProfileMenuItem } from './ProfileMenuItem.tsx';

export const DarkMode = () => {
  const lazyColorMode = useLazyColorMode();
  const [automaticColorModeToggled, setAutomaticColorModeToggled] = useState(
    lazyColorMode?.automaticColorMode ?? true,
  );
  const [darkModeToggled, setDarkModeToggled] = useState(
    lazyColorMode?.colorMode === 'darkMode',
  );

  useEffect(() => {
    if (lazyColorMode?.automaticColorMode) {
      setDarkModeToggled(lazyColorMode.colorMode === 'darkMode');
    }
  }, [lazyColorMode]);

  const toggleAutomaticColorMode = (toggled: boolean) => {
    setAutomaticColorModeToggled(toggled);
    lazyColorMode?.setAutomaticColorMode(toggled);
  };
  const toggleDarkMode = (toggled: boolean) => {
    setDarkModeToggled(toggled);
    lazyColorMode?.setColorMode(toggled ? 'darkMode' : 'lightMode');
  };

  return (
    <Stack space="none">
      <ProfileMenuItem
        onClick={() => toggleAutomaticColorMode(!automaticColorModeToggled)}
      >
        <Spread space="none">
          <Inline space="xxsmall" alignY="center">
            <Text>
              <IconRenderer>
                {({ className }) => (
                  <GearIcon
                    weight={automaticColorModeToggled ? 'fill' : 'regular'}
                    className={className}
                  />
                )}
              </IconRenderer>
            </Text>
            <Text
              size="small"
              weight={automaticColorModeToggled ? 'strong' : 'regular'}
            >
              Automatic
            </Text>
          </Inline>
          <Toggle
            label=""
            togglePosition="trailing"
            size="small"
            on={automaticColorModeToggled}
            id="color-mode-toggle"
            onChange={toggleAutomaticColorMode}
          />
        </Spread>
      </ProfileMenuItem>
      {!automaticColorModeToggled && (
        <ProfileMenuItem onClick={() => toggleDarkMode(!darkModeToggled)}>
          <Spread space="none">
            <Inline space="xxsmall" alignY="center">
              <Text>
                <IconRenderer>
                  {({ className }) => (
                    <MoonIcon
                      weight={darkModeToggled ? 'fill' : 'regular'}
                      className={className}
                    />
                  )}
                </IconRenderer>
              </Text>
              <Text
                size="small"
                weight={darkModeToggled ? 'strong' : 'regular'}
              >
                Dark Mode
              </Text>
            </Inline>
            <Toggle
              label=""
              togglePosition="trailing"
              size="small"
              on={darkModeToggled}
              id="color-mode-toggle"
              onChange={toggleDarkMode}
            />
          </Spread>
        </ProfileMenuItem>
      )}
    </Stack>
  );
};
